import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import { useSelector } from 'react-redux';

import { getBooleanLabel } from '@gef-ui/localization/messages';

import { codelists } from 'constants/codelists';
import { equalOrThreeDashes, fromIsoDate, getCodelistByName } from 'utils';
import { getClientName } from 'utils/client';

const ReportedDocumentTableRow = ({ doc }) => {
	const { text = '', documentTypeId } = doc;
	const client = getClientName(doc);
	const longText = text.length > 10;
	const textSlice = longText ? text.slice(0, 10).concat('...') : text;
	const ppDocumentTypeCodelist = useSelector(getCodelistByName(codelists.ppDocumentType));
	const documentType = ppDocumentTypeCodelist.find((type) => type.id === documentTypeId);

	return (
		<>
			<TableCell>{equalOrThreeDashes(client)}</TableCell>
			<TableCell>{equalOrThreeDashes(fromIsoDate(doc.reportedDate))}</TableCell>
			<TableCell>{equalOrThreeDashes(doc.policyNo)}</TableCell>
			<TableCell>{equalOrThreeDashes(documentType && documentType.shortDescription)}</TableCell>
			<TableCell>{equalOrThreeDashes(getBooleanLabel(doc.scanned))}</TableCell>
			<TableCell>{equalOrThreeDashes(textSlice)}</TableCell>
		</>
	);
};

ReportedDocumentTableRow.propTypes = {
	doc: PropTypes.object,
	ppDocumentType: PropTypes.array,
};

export default ReportedDocumentTableRow;
